import flow from 'lodash/flow';
import { AnalyticsSubject } from '@atlassian/jira-analytics-web-react/src/components/decorators.tsx';
import withFireUiAnalytics from '@atlassian/jira-analytics-web-react/src/components/with-fire-ui-analytics.tsx';
import ChartItems, { type APIProps } from './view';

export default flow(
	AnalyticsSubject('issue'),
	withFireUiAnalytics({
		onItemClick: 'issue',
	}),
)(ChartItems);

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export type { APIProps };
